<div class="drawer-header">
   <h4>Schedule Meeting</h4>
   <button
      class="v-button v-button-circle v-white v-graycolor"
      (click)="close()">
      <i class="icon fa fa-close"></i>
   </button>
</div>
<meeting-scheduler [subject]="data.subject"></meeting-scheduler>
